import { Button, Grid, Typography, Box } from '@mui/material';
import { useDispatch } from 'react-redux';
import { SET_FIRST_TIME_LOGIN, SET_MODAL_STATUS } from 'store/actions';

import AnnouncementImage from 'assets/images/dashboard/celeberatory/celebratory.svg';

function StillVerifyingModal() {
    const dispatch = useDispatch();

    return (
        <>
            <Box className="modal-body">
                <Grid container justifyContent={'space-between'} spacing={4}>
                    <Grid item xs={12} sm={6} sx={{ mt: 5 }}>
                        <Typography variant="h2" component="h2">
                            We are glad you are here!
                        </Typography>
                        <p>Congratulations on taking the first step towards having two-way communication with your investors</p>
                        <p>
                            Make sure to complete the onboarding checklist whilst we verify your account, better investor relationships are
                            right around the corner
                        </p>
                        <Button
                            className="alternate w-full"
                            variant="contained"
                            onClick={() => {
                                dispatch({ type: SET_MODAL_STATUS, modalStatus: false });
                                dispatch({ type: SET_FIRST_TIME_LOGIN, firstTimeLogin: false });
                            }}
                        >
                            Continue
                        </Button>
                    </Grid>
                    <Grid
                        item
                        sx={{
                            display: { xs: 'none', sm: 'block' }
                        }}
                        className="imageGrid"
                        sm={6}
                    >
                        <img src={AnnouncementImage} width={360} height={310} alt="announcement" />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default StillVerifyingModal;
